import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    FormHelperText,
    Checkbox,
    FormControlLabel, Link,
    Autocomplete
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from 'date-fns/locale';
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getHeadquarters } from "services/qrheadquarters";

const FormPersonNatural = (
    {
        values = {},
        handlerOnChange = () => {
        },
        newController = () => {
        },
        selfLabelInput = () => {

        },
        identificationTypes = [],
        genders = [],
        countries = [],
        cities = [],
        maxDate = null,
        spacing = 2,
        errors = {},
        hidden = false,
        isMobile = false,
        isCourtesie = false,
        assessors = [],
        minDate = null

    }
) => {
  const [searchParams] = useSearchParams();

  const venue = searchParams.get("v");
  const brand = searchParams.get("b");

  const [listVenues, setListVenues] = useState([]);

  useEffect(() => {
    if (brand && brand !== '') {
      getHeadquarters().then(({data}) => {
        setListVenues(data?.data?.filter((item) => Number(item.brand_id) === Number(brand)) ?? []);
      })
    }
  }, [brand]);

    return (
        <>
            {!hidden && <Grid container spacing={spacing}>
                <Grid item xs={4} md={6}>
                    {newController(
                        {
                            name: 'document_type_id',
                            render: ({ field }) => (
                                <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}
                                    style={{ marginTop: -16 }}>
                                    <InputLabel>{selfLabelInput(isMobile ? 'Tipo' : 'Tipo de identificación', true)}</InputLabel>
                                    <Select
                                        {...field}
                                        variant="standard"
                                        placeholder={selfLabelInput(isMobile ? 'Tipo' : 'Tipo de identificación', true)}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                            handlerOnChange(e);
                                        }}
                                        fullWidth
                                        size="small"
                                        value={values[{ ...field }.name] ?? ""}
                                    >
                                        {identificationTypes.length && identificationTypes.map((identificationType, index) => (
                                            <MenuItem key={index} value={identificationType.id}>
                                                {identificationType.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {!isMobile && errors[{ ...field }.name] && (
                                        <FormHelperText>
                                            {errors[{ ...field }.name][0]}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={8} md={6}>
                    {newController(
                        {
                            name: 'document_number',
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    size="small"
                                    placeholder={selfLabelInput('Número de identificación', true)}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handlerOnChange(e);
                                    }}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'name',
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Nombres', true)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'lastname',
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Apellidos', true)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12}>
                    {newController(
                        {
                            name: 'email',
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="email"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Correo electrónico', true)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'phone',
                            rules: { valueAsNumber: true },
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="number"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Télefono', true)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'phone_2',
                            rules: { required: false },
                            render: ({ field }) => (
                                <TextField
                                    hidden={hidden}
                                    error={!!errors[{ ...field }.name]}
                                    helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                    {...field}
                                    type="number"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Télefono fijo', false)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'gender',
                            render: ({ field }) => (
                                <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}>
                                    <Autocomplete
                                        {...field}
                                        onChange={(e, data) => handlerOnChange({ target: { name: 'gender', value: data?.id }})}
                                        options={genders}
                                        noOptionsText={"No hay registros"}
                                        name={field.name}
                                        getOptionLabel={(option) => option.name }
                                        renderInput={(params) => (
                                            <TextField
                                                label={'Género'}
                                                variant="standard"
                                                error={errors[{ ...field }.name]}
                                                {...params}
                                            />
                                        )}
                                    />
                                    {errors[{ ...field }.name] && (
                                        <FormHelperText>
                                            {errors[{ ...field }.name][0]}
                                        </FormHelperText>
                                    )}

                                </FormControl>
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6} mt={isMobile ? 2 : 0} alignItems={'center'} alignContent={'center'} textAlign={'center'}>
                    {newController(
                        {
                            name: 'birth_date',
                            render: ({ field }) => (
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                    <MobileDatePicker
                                        disableFuture
                                        error={!!errors[{ ...field }.name]}
                                        helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                        {...field}
                                        onChange={(value) => handlerOnChange({ target: { name: 'birth_date', value } })}
                                        value={values['birth_date'] ?? maxDate}
                                        renderInput={(props) =>
                                            <TextField
                                                hidden={hidden}
                                                variant="standard"
                                                {...props}
                                                fullWidth
                                            />
                                        }
                                        label={selfLabelInput('Fecha de nacimiento', true)}
                                        placeholder={selfLabelInput('Fecha de nacimiento', true)}
                                        inputFormat='dd/MM/yyyy'
                                        mask={'__/__/____'}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                    />
                                </LocalizationProvider>
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'country_id',
                            render: ({ field }) => (
                                <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}>
                                    <Autocomplete
                                        onChange={(e, data) => handlerOnChange({ target: { name: 'country_id', value: data?.id }})}
                                        options={countries}
                                        noOptionsText={"No hay registros"}
                                        getOptionLabel={(option) => option.name }
                                        renderInput={(params) => (
                                            <TextField
                                            label={'País'}
                                            variant="standard"
                                            error={errors[{ ...field }.name]}
                                            {...params}
                                            />
                                        )}
                                    />

                                    {errors[{ ...field }.name] && (
                                        <FormHelperText>
                                            {errors[{ ...field }.name][0]}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                    {newController(
                        {
                            name: 'city_id',
                            render: ({ field }) => (
                                <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}>
                                    <Autocomplete
                                        onChange={(e, data) => handlerOnChange({ target: { name: 'city_id', value: data?.id }})}
                                        options={cities}
                                        noOptionsText={"No hay registros"}
                                        getOptionLabel={(option) => option.name }
                                        renderInput={(params) => (
                                            <TextField
                                                label={'Ciudad'}
                                                variant="standard"
                                                error={errors[{ ...field }.name]}
                                                {...params}
                                            />
                                        )}
                                    />
                                    {errors[{ ...field }.name] && (
                                        <FormHelperText>
                                            {errors[{ ...field }.name][0]}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            )
                        }
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            {newController(
                                {
                                    name: 'address',
                                    render: ({ field }) => (
                                        <TextField
                                            hidden={hidden}
                                            error={!!errors[{ ...field }.name]}
                                            helperText={errors[{ ...field }.name] ? errors[{ ...field }.name][0] : null}
                                            {...field}
                                            type="text"
                                            fullWidth
                                            variant="standard"
                                            placeholder={selfLabelInput('Dirección', true)}
                                            onChange={handlerOnChange}
                                        />
                                    )
                                }
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                {
                    assessors?.length ? (
                        <Grid item xs={12}>
                            {newController(
                                {
                                    name: 'user_assigned',
                                    render: ({ field }) => (
                                        <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}>
                                            <InputLabel>{selfLabelInput('Asesor', false)}</InputLabel>
                                            <Select
                                                {...field}
                                                variant="standard"
                                                placeholder={selfLabelInput('Asesor', false)}
                                                onChange={handlerOnChange}
                                                fullWidth
                                                value={values[{ ...field }.name] ?? ""}
                                            >
                                                {assessors.length && assessors.map((assessor, index) => (
                                                    <MenuItem key={index} value={assessor.id}>
                                                        {`${assessor.first_name} ${assessor.last_name}`}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors[{ ...field }.user] && (
                                                <FormHelperText>
                                                    {errors[{ ...field }.user][0]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    )
                                }
                            )}
                        </Grid>
                    ): null
                }

                {(!venue || venue?.trim() === '') && <Grid Grid item xs={12}>
                  {newController(
                      {
                          name: 'venue_id',
                          render: ({ field }) => (
                              <FormControl fullWidth hidden={hidden} error={!!errors[{ ...field }.name]}>
                                  <InputLabel>{selfLabelInput('Sede', true)}</InputLabel>
                                  <Select
                                      {...field}
                                      variant="standard"
                                      placeholder={selfLabelInput('Sede', true)}
                                      onChange={handlerOnChange}
                                      fullWidth
                                      value={values[{ ...field }.name] ?? ""}
                                  >
                                      {listVenues.length && listVenues.map((venueItem, index) => (
                                          <MenuItem key={index} value={venueItem.id}>
                                              {venueItem.name}
                                          </MenuItem>
                                      ))}
                                  </Select>
                                  {errors[{ ...field }.name] && (
                                      <FormHelperText>
                                          {errors[{ ...field }.name][0]}
                                      </FormHelperText>
                                  )}
                              </FormControl>
                          )
                      }
                  )}
                </Grid>}

                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            {newController(
                                {
                                    name: 'terms_condition',
                                    render: ({ field }) => (
                                        <FormControl error={!!errors[{ ...field }.name]}>
                                            <FormControlLabel
                                                {...field}
                                                control={
                                                    <Checkbox
                                                        {...field}
                                                        onChange={(e) => {
                                                            handlerOnChange({
                                                                target: {
                                                                    name: 'term_condition',
                                                                    value: e.target.checked
                                                                }
                                                            })
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <div>
                                                        <span>Al seleccionar esta casilla acepto los </span>
                                                        <Link target="_blank"
                                                            href={'https://bodytech.com.co/terminos-y-condiciones'}>
                                                            términos y condiciones
                                                        </Link>
                                                        <span> y </span>
                                                        <Link target="_blank"
                                                            href={'https://bodytech-dev.s3.us-west-2.amazonaws.com/legal/PolA%CC%83_tica+de+Tratamiento+de+Datos+Personales+BODYTECH+(actualizaciA%CC%83%C2%B3n+2022).docx+(3).pdf'}>
                                                            políticas de tratamiento de datos
                                                        </Link>
                                                    </div>
                                                }
                                                hidden={hidden}
                                            />
                                            {errors[{ ...field }.name] && (
                                                <FormHelperText>
                                                    {errors[{ ...field }.name]}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    )
                                }
                            )}
                        </Grid>
                    </Grid>
                </Grid>

                {
                    !isCourtesie ?
                    <>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'related_information',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'related_information',
                                                                            value: !values.related_information
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span> Acepto recibir información relacionada con el bien y/o servicio adquirido</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'contact_email',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'contact_email',
                                                                            value: !values.contact_email
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Autorizo el envío de información comercial por email (correo electrónico)</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'contact_sms',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'contact_sms',
                                                                            value: !values.contact_sms
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Autorizo el envío de información comercial por mensaje de texto (SMS)</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'contact_app',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'contact_app',
                                                                            value: !values.contact_app
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Autorizo el envío de información comercial por aplicación (APP)</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'contact_whatsapp',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'contact_whatsapp',
                                                                            value: !values.contact_whatsapp
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Autorizo el envío de información comercial por Whatsapp</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {newController(
                                        {
                                            name: 'contact_phone',
                                            render: ({ field }) => (
                                                <FormControl error={!!errors[{ ...field }.name]}>
                                                    <FormControlLabel
                                                        {...field}
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                defaultChecked={true}
                                                                onChange={() => {
                                                                    handlerOnChange({
                                                                        target: {
                                                                            name: 'contact_phone',
                                                                            value: !values.contact_phone
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Autorizo el envío de información comercial vía telefónica</span>
                                                            </div>
                                                        }
                                                        hidden={hidden}
                                                    />
                                                    {errors[{ ...field }.name] && (
                                                        <FormHelperText>
                                                            {errors[{ ...field }.name][0]}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )
                                        }
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                    :<></>
                }
            </Grid>}
        </>
    );
};

export {
    FormPersonNatural
}
